import './index.scss';

import { ContextType } from 'react';

import ModalsContext from './components/BraxModals/context';
import ToastsContext from './components/BraxToasts/context';

export * from './types';
export { handleOAuthRedirect, ProviderCallback, ProviderCallbackResponse, ProviderPermissions, ProviderRedirectResponse } from './utils/oauth'
export * as i18n from './utils/i18n/IntlContext';
export { default as loader } from './utils/loader';
export { default as files } from './utils/files';

export * from './components/Brax3thPartyAuthButton';
export * from './components/BraxAlertBar';
export * from './components/BraxAppBar';
export * from './components/BraxAside';
export * from './components/BraxAsides';
export * from './components/BraxAvatar';
export * from './components/BraxButton';
export * from './components/BraxCard';
export * from './components/BraxCriticalError';
export * from './components/BraxDashedBorder';
export * from './components/BraxDropdown';
export * from './components/BraxFileButton';
export * from './components/BraxForm';
export * from './components/BraxGallery';
export * from './components/BraxHeader';
export * from './components/BraxIcon';
export * from './components/BraxImageEditor';
export * from './components/BraxList';
export * from './components/BraxLoading';
export * from './components/BraxLogo';
export * from './components/BraxModal';
export const BraxModals = ModalsContext;
export type BraxModalsType = ContextType<typeof ModalsContext>;
export * from './components/BraxNotice';
export * from './components/BraxNotification';
export * from './components/BraxProviders';
export * from './components/BraxStatus';
export * from './components/BraxStep';
export * from './components/BraxStepper';
export * from './components/BraxTab';
export * from './components/BraxTabs';
export { default as BraxTabsContext, TabsContextValue as BraxTabsContextType } from './components/BraxTabs/context';
export * from './components/BraxTable';
export * from './components/BraxToast';
export const BraxToasts = ToastsContext;
export type BraxToastsType = ContextType<typeof ToastsContext>;
export * from './components/BraxTooltip';
export * from './components/BraxTourOnboarding';
export * from './components/BraxUncontrolledForm';
export * from './components/BraxUserInfo';
